import { Box, InputBaseComponentProps } from '@mui/material'
import LeafletMap from 'components/Map/LeafletMap'
import { useRoutePlanning } from 'providers/RoutePlanningProvider'
import { renderToStaticMarkup } from 'react-dom/server'
import RoomIcon from '@mui/icons-material/Room'
import { ExpandMore } from '@mui/icons-material'
import Calendar from 'components/Calendar/Calendar'
import {
  ChangeEventHandler,
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from 'react'
import { useTranslation } from 'react-i18next'
import { DatePickerButton } from 'views/ServiceAreas/ServiceArea.styled'
// import TimePicker from 'components/TimePicker/TimePicker'
import { isToday } from 'date-fns'
import { formatDate } from 'lib/utils'
import theme from 'lib/theme'
import { Marker } from 'react-leaflet'
import { divIcon } from 'leaflet'
import { RouteMarker } from './RouteMarker'
import { DriverMarker } from './DriverMarker'

type MapWrapperProps = {
  latitude: number
  longitude: number
  date: Date
  setDate: Dispatch<SetStateAction<Date>>
}

type CalendarSelectInputProps = {
  onChange: ChangeEventHandler<HTMLInputElement>
  disabled: boolean
  inputProps: InputBaseComponentProps | undefined
  date: string
  open: boolean
  setOpen: (value: boolean) => void
  value: Date | null
}

// type TimePickerBtnProps = {
//   setOpen: (value: boolean) => void
//   open: boolean
//   value: Date
//   showIcon: boolean
// }

const CalendarSelectInput = ({
  onChange,
  disabled,
  inputProps,
  date,
  open,
  setOpen,
  value,
}: CalendarSelectInputProps) => {
  const { t } = useTranslation()
  return (
    <>
      <input
        style={{ display: 'none' }}
        value={date as string}
        onChange={onChange}
        disabled={disabled}
        {...inputProps}
      />
      <DatePickerButton
        data-cy='route planning date btn'
        variant='outlined'
        onClick={() => setOpen(!open)}
        endIcon={<ExpandMore />}>
        {isToday(value as Date) ? t('today') : formatDate(value as Date)}
      </DatePickerButton>
    </>
  )
}

// const TimePickerBtn = ({
//   setOpen,
//   open,
//   value,
//   showIcon,
// }: TimePickerBtnProps) => {
//   return (
//     <DatePickerButton
//       variant='outlined'
//       onClick={() => setOpen(!open)}
//       endIcon={<ExpandMore aria-hidden />}
//       startIcon={showIcon ? <AccessTime aria-hidden /> : null}>
//       {format(value, 'HH:mm')}
//     </DatePickerButton>
//   )
// }

const mapMarker = renderToStaticMarkup(
  <RoomIcon sx={{ width: theme.spacing(3), height: theme.spacing(3) }} />
)
const icon = divIcon({
  html: mapMarker,
  className: 'store_marker',
  iconSize: [24, 24],
  iconAnchor: [12, 24],
})
const MapWrapper = ({
  latitude,
  longitude,
  date,
  setDate,
}: MapWrapperProps) => {
  const {
    filterUnroutedOrdersBasedOnGivenTime,
    toggleDeliveriesToDisplay,
    setToggleDeliveriesToDisplay,
    shipmentsInOrder,
    getMarkers,
  } = useRoutePlanning()
  const { t } = useTranslation()
  const oneShipmentSelected = typeof toggleDeliveriesToDisplay === 'number'
  const markers = getMarkers()

  const midnightHour = new Date(date).setHours(0, 0, 0, 0)
  const endHour = new Date(date).setHours(23, 59, 0, 0)

  const [startTime] = useState(new Date(midnightHour))
  const [endTime] = useState(new Date(endHour))

  useEffect(() => {
    filterUnroutedOrdersBasedOnGivenTime(startTime, endTime)
    setToggleDeliveriesToDisplay('all')
  }, [startTime, endTime])

  useEffect(() => {
    setToggleDeliveriesToDisplay('all')
  }, [date])

  return (
    <LeafletMap
      latitude={latitude}
      longitude={longitude}
      zoom={15}
      height='100vh'>
      <Box mt={2} ml={2} display='flex' alignItems='center'>
        <Calendar
          selectBtn={CalendarSelectInput}
          ariaLabel={t('routePlanning.calendar-aria')}
          value={date}
          handleChange={(value) => setDate(value)}
          sx={{ zIndex: 1000 }}
        />
        {/* TODO: fix when time filter is available */}
        {/* <TimePicker
          datePickerButton={TimePickerBtn}
          value={startTime}
          minTime={new Date(date.setHours(0, 0, 0, 0))}
          handleChange={(value) => {
            setStartTime(value)
          }}
          ariaLabel={t('routePlanning.timePicker-startTime-aria', {
            date: startTime,
          })}
          sx={{ zIndex: 2000 }}
          showIcon
        /> */}
        {/* <Box
          display='flex'
          alignItems='center'
          height='28px'
          width='16px'
          zIndex={1000}
          bgcolor='neutral.grey9'>
          <Divider sx={{ borderColor: 'text.secondary', width: '80%' }} />
        </Box> */}

        {/* <TimePicker
        datePickerButton={TimePickerBtn}
          value={endTime}
          handleChange={(value) => setEndTime(value)}
          ariaLabel={t('routePlanning.timePicker-endTime-aria', {
            date: endTime,
          })}
          sx={{ zIndex: 2000 }}
          minTime={startTime}
        /> */}
      </Box>

      <Marker position={[latitude, longitude]} icon={icon} />

      <DriverMarker
        oneShipmentSelected={oneShipmentSelected}
        shipmentsInOrder={shipmentsInOrder}
      />

      {Object.keys(markers)?.map((latlng) => {
        const orderMarkers = markers[latlng]
        return (
          <RouteMarker
            key={latlng}
            orderMarkers={orderMarkers}
            latlng={latlng}
            oneShipmentSelected={oneShipmentSelected}
          />
        )
      })}
    </LeafletMap>
  )
}
export default MapWrapper
